module.exports = __webpack_public_path__ + "img/bg.1004e6ea.jpg";